import useI18n from '@app/shared/vue/composables/use-I18n'
import { comparisonModes } from '@app/insights/constants'

// The input kinds a comparison mode can be offered for. A filter's dropdown
// keeps only the modes whose visibleFor matches the input it renders.
export type ComparisonModeInput =
  | 'input'
  | 'dropdown'
  | 'checkbox'
  | 'date-input'

export type ComparisonModeOption = {
  label: string
  value: string
  visibleFor: ComparisonModeInput[]
}

type LabelOverride = { customLabel?: string | null }

export function numberComparisonModes(): ComparisonModeOption[] {
  return [
    { label: '=', value: comparisonModes.EQUAL, visibleFor: ['date-input'] },
    {
      label: '≠',
      value: comparisonModes.NOT_EQUAL,
      visibleFor: ['date-input'],
    },
    {
      label: '<',
      value: comparisonModes.LESS_THAN,
      visibleFor: ['date-input'],
    },
    {
      label: '>',
      value: comparisonModes.GREATER_THAN,
      visibleFor: ['date-input'],
    },
    {
      label: '≤',
      value: comparisonModes.LESS_THAN_OR_EQUAL,
      visibleFor: ['date-input'],
    },
    {
      label: '≥',
      value: comparisonModes.GREATER_THAN_OR_EQUAL,
      visibleFor: ['date-input'],
    },
  ]
}

export function showAllComparisonMode({
  customLabel = null,
}: LabelOverride = {}): ComparisonModeOption[] {
  const I18n = useI18n()

  return [
    {
      label:
        customLabel ||
        I18n.t('companies_overview.filters.comparison_modes.show_all'),
      value: comparisonModes.SHOW_ALL,
      visibleFor: ['input', 'dropdown', 'checkbox', 'date-input'],
    },
  ]
}

export function isComparisonMode({
  customLabel = null,
}: LabelOverride = {}): ComparisonModeOption[] {
  const I18n = useI18n()

  return [
    {
      label:
        customLabel || I18n.t('companies_overview.filters.comparison_modes.is'),
      value: comparisonModes.IS,
      visibleFor: ['dropdown'],
    },
  ]
}

export function isNotComparisonMode({
  customLabel = null,
}: LabelOverride = {}): ComparisonModeOption[] {
  const I18n = useI18n()

  return [
    {
      label:
        customLabel ||
        I18n.t('companies_overview.filters.comparison_modes.is_not'),
      value: comparisonModes.IS_NOT,
      visibleFor: ['dropdown'],
    },
  ]
}

export function untilStatusComparisonMode(): ComparisonModeOption[] {
  const I18n = useI18n()

  return [
    {
      label: I18n.t('companies_overview.filters.comparison_modes.up_to_status'),
      value: comparisonModes.UP_TO_STATUS,
      visibleFor: ['dropdown'],
    },
  ]
}

export function fromStatusComparisonMode(): ComparisonModeOption[] {
  const I18n = useI18n()

  return [
    {
      label: I18n.t('companies_overview.filters.comparison_modes.from_status'),
      value: comparisonModes.FROM_STATUS,
      visibleFor: ['dropdown'],
    },
  ]
}

export function textComparisonModes(): ComparisonModeOption[] {
  const I18n = useI18n()

  return [
    {
      label: I18n.t('companies_overview.filters.comparison_modes.containing'),
      value: comparisonModes.CONTAINS,
      visibleFor: ['input'],
    },
    {
      label: I18n.t('companies_overview.filters.comparison_modes.equal_to'),
      value: comparisonModes.EXACTLY,
      visibleFor: ['input', 'date-input'],
    },
  ]
}

export function booleanComparisonModes(): ComparisonModeOption[] {
  const I18n = useI18n()

  return [
    {
      label: I18n.t('companies_overview.filters.comparison_modes.true'),
      value: comparisonModes.TRUE,
      visibleFor: ['checkbox'],
    },
    {
      label: I18n.t('companies_overview.filters.comparison_modes.false'),
      value: comparisonModes.FALSE,
      visibleFor: ['checkbox'],
    },
  ]
}
